import { LIGHT, type Flavor } from '@protomaps/basemaps';

const JUSTIZ_NDS: Flavor = {
    ...LIGHT,

    regular: 'SourceSans3-Regular',
    bold: 'SourceSans3-Bold',
    italic: 'SourceSans3-Italic',
};

export default JUSTIZ_NDS;
